// extracted by mini-css-extract-plugin
module.exports = {"cell":"VIP_HierarchyCell__cell"};